import Cookies, { AnimatedCardProps } from "./Cookies";

export { Cookies, AnimatedCardProps };

export default Cookies;
